export default __webpack_public_path__ + "static/media/nv8.f86fa090.PNG";